import * as React from 'react';

const SvgIntroRequestMade = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3970)">
      <circle cx={21} cy={18} r={12} fill="#4397F7" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 12.6666C19 13.403 18.403 14 17.6667 14C16.9303 14 16.3333 13.403 16.3333 12.6666C16.3333 11.9303 16.9303 11.3333 17.6667 11.3333C18.403 11.3333 19 11.9303 19 12.6666ZM17.6667 14C16.5621 14 15.6667 14.5969 15.6667 15.3333C15.6667 16.0697 16.5621 16.6666 17.6667 16.6666C18.7712 16.6666 19.6667 16.0697 19.6667 15.3333C19.6667 14.5969 18.7712 14 17.6667 14ZM25 22C25.7364 22 26.3333 21.403 26.3333 20.6666C26.3333 19.9303 25.7364 19.3333 25 19.3333C24.2636 19.3333 23.6667 19.9303 23.6667 20.6666C23.6667 21.403 24.2636 22 25 22ZM25 22C26.1046 22 27 22.5969 27 23.3333C27 24.0697 26.1046 24.6666 25 24.6666C23.8954 24.6666 23 24.0697 23 23.3333C23 22.5969 23.8954 22 25 22ZM20.5 12C20.5 11.7238 20.7239 11.5 21 11.5C24.5899 11.5 27.5 14.4101 27.5 18C27.5 18.2761 27.2761 18.5 27 18.5C26.7239 18.5 26.5 18.2761 26.5 18C26.5 14.9624 24.0376 12.5 21 12.5C20.7239 12.5 20.5 12.2761 20.5 12ZM15 17.5C15.2761 17.5 15.5 17.7238 15.5 18C15.5 21.0375 17.9624 23.5 21 23.5C21.2761 23.5 21.5 23.7238 21.5 24C21.5 24.2761 21.2761 24.5 21 24.5C17.4101 24.5 14.5 21.5898 14.5 18C14.5 17.7238 14.7239 17.5 15 17.5Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3970"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3970"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3970"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3970"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgIntroRequestMade;
